const actions = {
  setLoading: ({ commit }, status) =>
    commit('status', status)

}

export default actions
